export enum SkillStatus {
    SKILL = "SKILL",
    NON_SKILL = "NON_SKILL",
    PARTIAL = "PARTIAL",
    NONE = "NONE"
}
